import React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

/**
 * ConfirmDialog — shadcn AlertDialog wrapper.
 *
 * Usage:
 *   <ConfirmDialog
 *     open={open}
 *     onOpenChange={setOpen}
 *     title="Delete this lead?"
 *     description="This will also remove any pending Stripe proposals attached to it."
 *     confirmLabel="Delete"
 *     destructive
 *     onConfirm={handleDelete}
 *   />
 */
export default function ConfirmDialog({
  open,
  onOpenChange,
  title,
  description,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  destructive = false,
  onConfirm,
  testid,
}) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent
        data-testid={testid || "confirm-dialog"}
        className="bg-zinc-950 border-zinc-800 text-zinc-100 rounded-sm"
      >
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display text-zinc-50">{title}</AlertDialogTitle>
          {description ? (
            <AlertDialogDescription className="text-zinc-400 text-sm">{description}</AlertDialogDescription>
          ) : null}
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel
            data-testid={`${testid || "confirm-dialog"}-cancel`}
            className="bg-zinc-900 border-zinc-800 hover:bg-zinc-800 text-zinc-200 rounded-sm"
          >
            {cancelLabel}
          </AlertDialogCancel>
          <AlertDialogAction
            data-testid={`${testid || "confirm-dialog"}-confirm`}
            onClick={onConfirm}
            className={
              destructive
                ? "bg-red-600 hover:bg-red-500 text-zinc-50 rounded-sm"
                : "bg-orange-600 hover:bg-orange-500 text-zinc-950 rounded-sm"
            }
          >
            {confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
